import { bugNotif } from "../../api/bugsnag";
import { getErrorMsg } from "../../../Common/utils/common";

declare const dataLayer: unknown[];

export const sendgtag = async (transactionId: string, value: number) => {
  try {
    dataLayer.push({
      event: "purchase",
      transaction_id: transactionId,
      value,
      currency: "AUD",
    });
  } catch (error) {
    console.log("error sendgtag", error);
    bugNotif("sendgtag", getErrorMsg(error).rawErrorMsg);
  }
};

